import { API_ENDPOINT, Logger } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useTradeForm } from "@/hooks/trading/form/useTradeForm";
import { useHubUser } from "@/hooks/user/useHubUser";
import { useAntiBotVerification } from "@/providers/AntiBotVerificationProvider";

export const useVerifyOrder = () => {
  const apiHelper = useApi();
  const { auth } = useHubUser();
  const { executeTurnstile } = useAntiBotVerification();
  const { tradeForm } = useTradeForm();

  /**
   * Verify if an order has been executed by a bot or not
   *
   * @param orderId
   */
  const verifyOrder = async (orderId: string) => {
    try {
      // We don't want to verify the order if the campaign is not set
      if (!tradeForm.initialProps.campaignId) return;
      if (!auth.identityToken) return;

      const turnstileToken = await executeTurnstile();
      if (turnstileToken) {
        await apiHelper.postAuth(auth, API_ENDPOINT.HUB_TRADE_VERIFY_ORDER, {
          bodyParams: { orderId, turnstileToken },
        });
      }
    } catch (error) {
      Logger.error(error);
    }
  };

  return { verifyOrder };
};
